import { Col, DatePicker, Form, Input, Row } from 'antd';
import Flex from 'components/shared-components/Flex';
import React, { useState } from 'react'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useEffect } from 'react';
import ReactQuill from 'react-quill';

const ExperienceAddFields = ({ field, remove, form, index }) => {

    const [joiningDate, setJoiningDate] = useState(null)
    const [relievingDate, setRelievingDate] = useState(null)

    useEffect(() => {
        if(form.getFieldValue('experienceDetails')) {
            setJoiningDate(form.getFieldsValue().experienceDetails[index] ? form.getFieldsValue().experienceDetails[index].joiningDate : null)
            setRelievingDate(form.getFieldsValue().experienceDetails[index] ? form.getFieldsValue().experienceDetails[index].relievingDate : null)
        }
    }, [form, index])

  return (
    <div>
    <Flex justifyContent='end'>
        <MinusCircleOutlined

            style={{ fontSize: '20px', color: 'red' }}
            className="dynamic-delete-button"
            onClick={() => {
                remove(field.name);
            }}
        />

    </Flex>

    <Row gutter={8} >
        <Col md={6}>
            <Form.Item
                {...field}

                name={[field.name, 'companyName']}
                label="Company name"
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                    {
                        required: true,
                        whitespace: true
                    },
                ]}

            >
                <Input placeholder="Company name" />
            </Form.Item>
        </Col>
        <Col md={6}>
            <Form.Item
                {...field}
                name={[field.name, 'desig']}
                label="Designation"
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                    {
                        required: true,
                        whitespace: true
                    },
                ]}

            >
                <Input placeholder="Designation" />
            </Form.Item>
        </Col>
        <Col md={6}>
            <Form.Item
                {...field}
                name={[field.name, 'joiningDate']}
                label="Joining date"

                rules={[
                    {
                        required: true
                    },
                ]}

            >
                <DatePicker 
                    className='w-100' 
                    placeholder="Joining Date" 
                    onChange={(e) => setJoiningDate(e)} 
                    disabledDate={(current) => {
                        let customDate = moment().format("DD-MM-YYYY");
                        return current && current > moment(customDate, "DD-MM-YYYY");
                    }} 
                />
            </Form.Item>
        </Col>
        <Col md={6}>
            <Form.Item
                {...field}
                name={[field.name, 'relievingDate']}
                label="Relieving date"

                rules={[
                    {
                        required: true
                    },
                    () => ({
                        validator(rule, value) {
                            if (moment(joiningDate).diff(moment(value)) < 0) {
                                return Promise.resolve();
                            }
                            return Promise.reject("Relieving date must be greater than joining date")
                        },
                    }),
                ]}

            >
                <DatePicker 
                    className='w-100' 
                    placeholder="Relieving Date" 
                    onChange={e => setRelievingDate(e)} 
                    disabledDate={(current) => {
                        let customDate = moment().format("DD-MM-YYYY");
                        return current && current > moment(customDate, "DD-MM-YYYY");
                    }} 
                />
            </Form.Item>
        </Col>
        <Col span={24}>
            <Form.Item {...field} initialValue='' rules={[{required: true}]} name={[field.name,"expDescp"]} label="Description" >
                <ReactQuill theme="snow" />
            </Form.Item>
        </Col>
    </Row>
</div>
  )
}

export default ExperienceAddFields